import { createContext, useReducer } from 'react'

export const AccountContext = createContext()

export const accountsReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_USER':
            return {
                ...state,
                account: action.payload
            }
        case 'UPDATE_EMERGENCY_INFORMATION':
            return {
                ...state,
                emergencyInformation: action.payload
            }
        case 'UPDATE_PENDING_ACTIVITIES_COUNT':
            return {
                ...state,
                pendingActivitiesCount: action.payload
            }
        case 'UPDATE_LEAVE_ANALYSIS':
            return {
                ...state,
                leaveAnalysis: action.payload
            }
        case 'UPDATE_REMAINING_AL':
            return {
                ...state,
                ALRemaining: action.payload
            }
        case 'UPDATE_REMAINING_SL':
            return {
                ...state,
                SLRemaining: action.payload
            }
        case 'UPDATE_MANAGER_EMPLOYEES':
            return {
                ...state,
                managerEmployees: action.payload
            }
        case 'UPDATE_OASIS_PARAM':
            return {
                ...state,
                oasisParam: action.payload
            }
        case 'UPDATE_TEAM':
            return {
                ...state,
                team: action.payload
            }
        case 'UPDATE_COMPANY':
            return {
                ...state,
                companyDetails: action.payload
            }
        case 'UPDATE_ORGCHART':
            return {
                ...state,
                orgChart: action.payload
            }
        case 'UPDATE_REP_USERROLES':
            return {
                ...state,
                repGrpUserRoles: action.payload.jsonReportGroups,
                repRepUserRoles: action.payload.jsonReports
            }
        case 'RESET_STATE':
            return {
                account: null,
                pendingActivitiesCount: 0,
                leaveAnalysis: null,
                ALRemaining: 0,
                SLRemaining: 0,
                managerEmployees: null,
                oasisParam: null,
                team: null,
                companyDetails: null,
                orgChart: null,
                repGrpUserRoles: null,
                repRepUserRoles: null,
            }
        default:
            return state
    }
}

export const AccountProvider = ({ children }) => {
    const [state, dispatch] = useReducer(accountsReducer, {
        account: null,
        pendingActivitiesCount: 0,
        leaveAnalysis: null,
        ALRemaining: 0,
        SLRemaining: 0,
        managerEmployees: null,
        oasisParam: null,
        team: null,
        companyDetails: null,
        orgChart: null,
        repGrpUserRoles: null,
        repRepUserRoles: null,
    })

    return (
        <AccountContext.Provider value={{ ...state, dispatch }}>
            {children}
        </AccountContext.Provider>
    )
}